import {
  all,
  fork,
  takeEvery,
  put,
} from 'redux-saga/effects';

import { ARBITER_MSG_RECEIVED } from './actions';

// Watcher sagas
function* watchArbiterMessages() {
  yield takeEvery(ARBITER_MSG_RECEIVED, handleArbiterMessage);
}

// Worker sagas
function* handleArbiterMessage(action:any) {
  const {payload} = action; // The payload is an entire redux action in itself, sent down from arbiter

    // Any custom logic in handling arbiter messages here

    yield put(payload);
}

export default function* ArbiterSagas() {
  yield all([
    fork(watchArbiterMessages),
  ]);
}
